import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Lateral que abre sozinha: no notebook ela fica como uma faixa de ícones e
 * se abre por cima do conteúdo quando o mouse entra; quando ele sai, recolhe.
 * Quem preferir a lateral sempre aberta fixa pelo botão do topo (a escolha
 * fica salva em `chave`). No toque não há "passar por cima": vale a gaveta.
 */
export function useLateralAutomatica(chave: string, fixadaPorPadrao = false) {
  const [fixada, setFixada] = useState(() => {
    try {
      const preferencia = localStorage.getItem(chave);
      return preferencia === null ? fixadaPorPadrao : preferencia === 'true';
    } catch {
      return fixadaPorPadrao;
    }
  });
  const [sobre, setSobre] = useState(false);
  const espera = useRef<number>();

  const alternarFixada = useCallback(() => {
    setFixada((antes) => {
      const agora = !antes;
      try {
        localStorage.setItem(chave, String(agora));
      } catch {
        /* navegação privada: vale só nesta visita */
      }
      return agora;
    });
  }, [chave]);

  // Uma folga curta para abrir (o mouse só atravessando a borda não abre) e
  // quase nenhuma para fechar ("tirou o mouse, recolheu").
  const entrar = useCallback(() => {
    window.clearTimeout(espera.current);
    espera.current = window.setTimeout(() => setSobre(true), 90);
  }, []);
  const sair = useCallback(() => {
    window.clearTimeout(espera.current);
    espera.current = window.setTimeout(() => setSobre(false), 60);
  }, []);

  useEffect(() => () => window.clearTimeout(espera.current), []);

  const eventos = {
    onPointerEnter: (e: React.PointerEvent) => {
      if (e.pointerType !== 'touch') entrar();
    },
    onPointerLeave: (e: React.PointerEvent) => {
      if (e.pointerType !== 'touch') sair();
    },
    onFocus: entrar,
    onBlur: (e: React.FocusEvent) => {
      if (!e.currentTarget.contains(e.relatedTarget as Node | null)) sair();
    },
  };

  return { fixada, alternarFixada, sobre, eventos };
}
